export default "__VITE_ASSET__XwYSn10f__"